
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry, DateFilterModule, } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button } from '@mui/material';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import '../../../../AgGridStyle.css';
import HomeIcon from '@mui/icons-material/Home';
import { getShiftMasterdropdata, getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';

ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule,]);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const WeekAllocationtable = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const permissions = usePermissions("Promocode Master");
    const { AddRec = "0" } = permissions || {};
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);

    const dateComparator = (filterDate, cellValue) => {
        if (cellValue == null) return -1;

        const cellDate = new Date(cellValue);
        cellDate.setHours(0, 0, 0, 0);

        const filterDateObj = new Date(filterDate);
        filterDateObj.setHours(0, 0, 0, 0);

        if (cellDate < filterDateObj) return -1;
        if (cellDate > filterDateObj) return 1;
        return 0;
    };

    const colDefs = useMemo(() => [
        { field: 'PropName', headerName: 'Property', width: 280 },
        { field: 'ShiftName', headerName: 'Shift', width: 240 },

        {
            field: 'WrkRecvDt',
            headerName: 'Received Date',
            width: 260,
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: dateComparator,
                browserDatePicker: true,
                minValidYear: 2000,
                maxValidYear: 2030,
            },
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                return date.toLocaleDateString('en-IN');
            }
        },
        // { field: 'PlanedCount', headerName: 'Planed Task', width: 240 },
        { field: 'CompleteCount', headerName: 'Completed Task', width: 240 },
        { field: 'Remark', headerName: 'Remark', width: 340 },
        // { 
        //     field: 'Ratio', 
        //     headerName: 'Completion Ratio', 
        //     width: 280,
        //     valueGetter: (params) => {
        //         if (!params.data) return '';
        //         const planned = params.data.PlanedCount || 0;
        //         const completed = params.data.CompleteCount || 0;

        //         if (planned === 0) return '0%';
        //         const ratio = (completed / planned) * 100;
        //         return `${ratio.toFixed(2)}%`;
        //     },
        //     cellStyle: (params) => {
        //         const value = params.value;
        //         if (!value) return {};

        //         const percentage = parseFloat(value);
        //         if (percentage >= 75) {
        //             return { backgroundColor: '#e8f5e8', color: '#2e7d32', fontWeight: 'bold' };
        //         } else if (percentage >= 50) {
        //             return { backgroundColor: '#fff3e0', color: '#f57c00', fontWeight: 'bold' };
        //         } else {
        //             return { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' };
        //         }
        //     }
        // },
    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: true,
        width: 100,
        tooltipValueGetter: (params) => params.value ?? '',
    }), []);

    const fetchReportData = async () => {
        setIsLoading(true);
        try {
            const payload = {
                PropId: globalProperty || 0,
                "start": 1,
                "PageSize": 1,
                "SearchText": "",
                "Flag": "WrkRecDash"

            };

            const response = await axiosInstance.post(
                'MstYojana/GetTrnWrkRecvDashBoard',
                payload
            );

            if (response.data.Status === 0 && response.data.Data?.length > 0) {
                const formattedData = response.data.Data.map((item, index) => ({
                    ...item,
                    RowNum: index + 1
                }));
                setRowData(formattedData);
            } else {
                setRowData([]);
                toast.info(response.data.Message || 'No data found for selected criteria');
            }
        } catch (error) {
            toast.error('Error fetching  data');
            setRowData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchReportData();
    }, [globalProperty]);

    const handleRowDoubleClick = (params) => {
        const selectedData = params.data;
        const propId = selectedData.PropId;
        const shiftId = selectedData.ShiftId;
        const date = selectedData.WrkRecvDt;

        navigate('/operations/weeklyallocation', {
            state: {
                selectedData,
                propId: propId,
                shiftId: shiftId,
                date: date
            }
        });
    };

    const onGridReady = useCallback((params) => {
    }, []);

    const handlePermittedClick = () => {
        navigate('/operations/weeklyallocation');
    };

    return (
        <Box
            sx={{
                width: '100%',
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative'
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                    flexDirection: { xs: "column", sm: "column", md: "row" },
                    gap: 2,
                }}
            >
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" }
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500" }}
                        onClick={() => navigate('/operations/housekeepin')}
                    >
                        Operation
                    </Link>
                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Summary
                    </Typography>
                </Breadcrumbs>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
                        justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
                        width: { xs: "100%", md: "auto" }
                    }}
                >
                    <Tooltip
                        title={AddRec !== "1" ? "You have no permission to add record" : "Add New Record"}
                        placement="top"
                        arrow
                    >
                        <span>
                            <Button
                                variant="contained"
                                onClick={handlePermittedClick}
                                size="small"
                                disabled={AddRec !== "1"}
                                sx={{
                                    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
                                    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
                                    borderRadius: "50px",
                                    padding: "6px 15px",
                                    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.2)" : "none",
                                    "&:hover": {
                                        background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
                                    }
                                }}
                            >
                                <AddIcon fontSize="small" sx={{ mr: 0.5 }} /> New
                            </Button>
                        </span>
                    </Tooltip>

                    <Tooltip title='Previous Page' arrow>
                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <IconButton
                                onClick={() => navigate('/operations/housekeepin')}
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': {
                                        backgroundColor: '#635bff',
                                    },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>

            <Box
                className="ag-theme-alpine"
                sx={{
                    height: 'calc(100% - 100px)',
                    width: '95%',
                    margin: '0 auto',
                    position: 'relative'
                }}
            >
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />
                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : (
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={100}
                        paginationPageSizeSelector={[100, 1000, 5000]}
                        onGridReady={onGridReady}
                        enableCellTextSelection={true}
                        rowHeight={25}
                        headerHeight={35}
                        onRowDoubleClicked={handleRowDoubleClick}
                        floatingFiltersHeight={30}
                        overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No data to display</span>'}
                        tooltipShowDelay={0}
                        getRowStyle={(params) => ({
                            backgroundColor: params.node.rowIndex % 2 === 0 ? '#f8f9fa' : '#ffffff',
                            cursor: 'pointer'
                        })}
                    />
                )}
                {rowData.length > 0 && (
                    <Box sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 70,
                        fontSize: '14px',
                        color: 'black',
                    }}>
                        Total Records: <b>{rowData.length}</b>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default WeekAllocationtable;